const React = require('react');
const withReDelay = require('mn-utils/withReDelay');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonUp = require('../../../dumb/Button/Up');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');
const {IntervalFilterAdmin, getFilterParams, initFilter} = require('../../../dumb/IntervalFilterCustom');

const statusesFilters = require('./constants/statusesFilters');
const TableItem = require('./components/TableItem');
const {default: RefreshIcon} = require("@material-ui/icons/Refresh");
const ButtonD = require("../../../dumb/Button/D");
const ColB2 = require("../../../dumb/Col/B2");
const openCreatePopup = require("./utils/openCreatePopup");
const {default: AddCircleOutlineIcon} = require("@material-ui/icons/AddCircleOutline");
const {API_URL_HOST} = require("../../../../config/api");

const filter$ = initFilter();

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$
  },
  rowHeight: 70,
  request: require('../../../../api/admin/auctions').apiAdminAuctionsList,
  getParams: getFilterParams('status'),
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;

      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Auctions</CaptionA>
            <div className="layoutRow aiC mh-10 ph10>1">
              <div>
                <ButtonD
                  onClick={() => {
                    openCreatePopup(update)
                  }}
                >
                  <AddCircleOutlineIcon/>
                  <div className="pl15">Add Auction</div>
                </ButtonD>
              </div>
              <div>
                <ButtonD
                  className="wmin100"
                  onClick={self.update}
                >
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </div>
            </div>
          </HeaderA>
          <IntervalFilterAdmin
            className="mt16"
            data={filter}
            onChange={handleChangeFilter}
            search={{
              className: 'w290',
              placeholder: 'Search by ID / Email / Amount'
            }}
            selectFilters={[statusesFilters]}
            // enableAmountRange
          />
          <div className="rlv h100vh-380 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin1450 rlv h">
                <div>
                  <RowB className="f14">
                    <ColB className="wmin155 fx1">ID</ColB>
                    <ColB className="wmin120">Date & Time</ColB>
                    <ColB className="wmin110 fx1">Merchant</ColB>
                    <ColB className="wmin110 fx1">Customer</ColB>
                    <ColB className="wmin100 fx1">Auction<br/>status</ColB>
                    <ColB className="wmin140 fx1">Fiat Amount</ColB>
                    <ColB className="wmin180 fx1">CC Amount</ColB>
                    <ColB className="wmin80 fx1">Rate</ColB>
                    {/*<ColB className="w wmin100">Payment<br/>status</ColB>*/}
                    <ColB className="wmin180 fx1">Hash</ColB>
                    <ColB className="wmin160 fx1">Order status</ColB>
                    <ColB2 className="w50"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(TableItem)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
